import type { FindFn } from "@shared/models/analytics/base"
import { createBlankEvent } from "@shared/models/analytics/base"
import type { PlanbookEditCalendar } from "@shared/models/analytics/planbook"
import { getPossessiveForPlanbook } from "@shared/models/analytics/planbook"
import Patch from "@shared/models/patch-updater"
import moment from "moment"
import type { Narrative } from "../create-narrative"

export default {
  name: "PLANBOOK_DATE_RESET_TO_TEMPLATE",

  params: {
    courseId: "string",
    dateId: "string",
    dateString: "string",
    currentCardStackId: "string",
  },

  patches(payload) {
    return [
      Patch.create("planbook", payload.planbookId, "attributes.calendar.dates", {
        id: payload.dateId,
      })
        .set("embedded", "attributes.cardStackId", null)
        .inc("attributes.calendar.version", 1).patch,
    ]
  },

  undoPatches(payload) {
    return [
      Patch.create("planbook", payload.planbookId, "attributes.calendar.dates", {
        id: payload.dateId,
      })
        .set("embedded", "attributes.cardStackId", payload.currentCardStackId)
        .inc("attributes.calendar.version", 1).patch,
    ]
  },

  narrative(payload, findFn: FindFn, userId): Narrative {
    let planbook = findFn("planbook", payload.planbookId)
    let formattedDate = moment(payload.dateString).format("ddd. MMM. D, YYYY")
    let shortFormattedDate = moment(payload.dateString).format("MMM. D YYYY")

    let newEvent: PlanbookEditCalendar = {
      ...createBlankEvent(),
      root_id: payload.planbookId,
      root_type: "planbook",
      primary_object_type: "planbook",
      primary_possessive: getPossessiveForPlanbook(findFn, userId, payload.planbookId),
      primary_object_id_and_ancestor_ids: [payload.planbookId],
      primary_verb: "edit",
      primary_object_specifier: "calendar",
      adverbial_verb: "removing",
      adverbial_object_type: "course_order",
    }

    return {
      title: `Reset ${shortFormattedDate} to the normal schedule`,
      titleForAnalytics: "Planbook - Reset Date to Template",
      description: `Reset ${formattedDate} so it will use the schedule for a normal ${payload.rotationDayTitle}`,
      context: {
        planbookTitle: planbook.attributes.title,
        dateString: payload.dateString,
        planbookId: planbook.id,
      },
      activity: {
        actor: `user-${userId}`,
        verb: "edited",
        object: `planbook-${planbook.id}`,
        to: [`planbook-edits:planbook-${planbook.id}`],
      },
      newAnalyticsEvents: [newEvent],
    }
  },
}
